import React from "react";
import MUIDataTable from "mui-datatables";
import { createMuiTheme, MuiThemeProvider } from "@material-ui/core/styles";

import axios from "axios";
import Fab from "@material-ui/core/Fab";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import { TextField } from "@material-ui/core";
import { Container, Row, Col } from "shards-react";
import CircularProgress from "@material-ui/core/CircularProgress";
import CustomToolbar from "../common/AddButton";
import Backdrop from "@material-ui/core/Backdrop";
import Typography from "@material-ui/core/Typography";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import RefreshIcon from "@material-ui/icons/Refresh";
import AddAlertIcon from "@material-ui/icons/AddAlert";

import Button from "@material-ui/core/Button";

import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
//import { Store } from "../../flux";
import api from "../common/api";

class ProviderUsers extends React.Component {
  constructor() {
    super();

    this.state = {
      data: "",
      isLoaded: false,
      backdrop: false,
      users: [],
      reset_emails: []
    };
  }

  async componentDidMount() {
    await this.getUsers();
  }

  getUsers() {
    const token = localStorage.getItem("userToken");

    return axios
      .get(api.providerUsers().index(), {
        headers: { Authorization: `Bearer ${token}` }
      })
      .then(res => {
        this.setState({ isLoaded: true, users: res.data });
      })
      .catch(err => {
        this.setState({ isLoaded: true, users: [] });
      });
  }

  getMuiTheme = () =>
    createMuiTheme({
      overrides: {
        MuiTableCell: {
          root: {
            padding: "0px 8px 0px 8px",
            fontSize: "0.73rem"
          }
        }
      }
    });

  handleDelete(e, id) {
    e.preventDefault();
    this.state.users.map((val, idx) => {
      if (val.id === id) {
        this.setState({ delete_id: val.id });
      }
    });

    var message = "";
    if (id !== "") {
      message = "Está a punto de dar de baja al usuario. ¿Está seguro?";
    } else {
      message = "Hubo un problema al dar de baja al usuario.";
    }
    this.setState({ message: message, dialogOpen: true });
  }

  handleDialogClose(e) {
    e.preventDefault();
    this.setState({
      dialogOpen: false,
      errors: false,
      message: "",
      delete_id: ""
    });
  }

  handleRefresh(e) {
    e.preventDefault();
    window.location.href = `/provider/users`;
  }

  handleCloseBackdrop = () => {
    var backdrop = !this.state.backdrop;
    this.setState({ backdrop: backdrop });
  };

  confirmDelete() {
    const token = localStorage.getItem("userToken");
    return axios
      .delete(api.users().delete(this.state.delete_id), {
        headers: { Authorization: `Bearer ${token}` }
      })
      .then(res => {
        this.setState({ message: "Usuario dado de baja con éxito!" });
        this.setState({ errors: false });
        this.setState({ delete_id: "" });
      })
      .catch(err => {
        this.setState({ errors: true });
        this.setState({ delete_id: "" });
        this.setState({ message: "" });
      });
  }

  render() {
    const columns = [
      {
        name: "id",
        label: "Id",
        options: {
          filter: false,
          sort: true,
          display: false
        }
      },
      {
        name: "subcontact.contact.hansa_code",
        label: "Hansa Code",
        options: {
          filter: true,
          filterType: "textField",
          sort: true,
          display: true
        }
      },
      {
        name: "subcontact.firstname",
        label: "Nombre",
        options: {
          filter: true,
          filterType: "textField",
          sort: true
        }
      },
      {
        name: "subcontact.lastname",
        label: "Apellido",
        options: {
          filter: true,
          filterType: "textField",
          sort: true
        }
      },
      {
        name: "email",
        label: "Email",
        options: {
          filter: true,
          filterType: "textField",
          sort: true
        }
      },
      {
        name: "provider",
        label: "Proveedor",
        options: {
          filter: true,
          filterType: "textField",
          sort: true,
          display: false
        }
      },
      {
        name: "subcontact.id",
        label: "Id Subcontacto",
        options: {
          filter: false,
          display: false
        }
      },
      {
        name: "Acciones",
        label: "",
        options: {
          filter: false,
          setCellHeaderProps: () => ({ align: "center" }),
          customBodyRender: (value, tableMeta, updateValue) => {
            const rowId = tableMeta.rowData[0];
            const userID = tableMeta.rowData[1];
            const subcontactID = tableMeta.rowData[6];
            //const rowId = 1
            return (
              <div className="row" style={{ display: "block" }}>
                {rowId ? (
                  <Fab
                    color="primary"
                    aria-label="view"
                    variant="extended"
                    style={{ boxShadow: "none", backgroundColor: "green" }}
                    fontSize="small"
                    className="MuiButtonBase-root MuiFab-sizeSmall mr-2"
                    href={"/providers/user/" + subcontactID}
                  >
                    <EditIcon fontSize="small" />
                  </Fab>
                ) : (
                  ""
                )}
                <Fab
                  color="primary"
                  aria-label="view"
                  variant="extended"
                  style={{ boxShadow: "none" }}
                  fontSize="small"
                  className="MuiButtonBase-root MuiFab-sizeSmall mr-2"
                  onClick={e => {
                    this.handleDelete(e, rowId);
                  }}
                >
                  <DeleteIcon fontSize="small" />
                </Fab>
              </div>
            );
          }
        }
      }
    ];

    const options = {
      print: false,
      responsive: "stacked",
      selectableRowsOnClick: true,
      download: true,
      onDownload: () => {
        this.setState({ backdrop: true });
        this.handleDownload();
        return false;
      },
      rowsPerPage: 10,
      textLabels: {
        toolbar: {
          search: "Buscar",
          viewColumns: "Ver columnas",
          filterTable: "Filtros",
          downloadCsv: "Exportar XLS"
        },
        body: {
          noMatch: this.state.isLoaded ? (
            "No hay resultados"
          ) : (
            <CircularProgress />
          )
        },
        selectedRows: {
          text: "fila(s) seleccionadas"
        },
        viewColumns: {
          title: "Ver columnas"
        },
        pagination: {
          next: "Siguiente",
          previous: "Anteior",
          rowsPerPage: "Cantidad por página:",
          displayRows: "de"
        },
        filter: {
          all: "Todos",
          title: "Filtros",
          reset: "Limpiar"
        }
      }
    };

    return (
      <Container fluid className="main-content-container px-4">
        <Row>
          <Col className="p-2">
            <div>
              <Dialog
                open={this.state.dialogOpen}
                onClose={e => this.handleDialogClose(e)}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
              >
                <DialogTitle id="alert-dialog-title">
                  Administracion usuarios
                </DialogTitle>
                <DialogContent>
                  <DialogContentText id="alert-dialog-description">
                    {this.state.message}
                  </DialogContentText>
                </DialogContent>
                <DialogActions>
                  {!this.state.errors ? (
                    this.state.delete_id === "" ||
                    this.state.reset_emails.length === 0 ? (
                      <div>
                        <Button
                          onClick={e => {
                            this.handleRefresh(e);
                          }}
                          color="primary"
                        >
                          Continuar
                        </Button>
                      </div>
                    ) : (
                      <div>
                        <Button
                          onClick={e => this.handleDialogClose(e)}
                          color="primary"
                          autoFocus
                        >
                          Cancelar
                        </Button>
                        <Button
                          onClick={
                            this.state.reset_emails.length > 0
                              ? this.sendResetPassword()
                              : this.confirmDelete.bind(this)
                          }
                          color="primary"
                        >
                          Continuar
                        </Button>
                      </div>
                    )
                  ) : (
                    <div>
                      <Button
                        onClick={e => this.handleDialogClose(e)}
                        color="primary"
                      >
                        Continuar
                      </Button>
                    </div>
                  )}
                </DialogActions>
              </Dialog>
            </div>
            <div>
              <Backdrop
                open={this.state.backdrop}
                onClick={this.handleCloseBackdrop}
                style={{ zIndex: 10000, color: "#3f51b5" }}
              >
                <CircularProgress color="inherit" />{" "}
                <Typography className="ml-2" variant="h5" color="primary">
                  Descargando...
                </Typography>
              </Backdrop>
              <MuiThemeProvider theme={this.getMuiTheme()}>
                <MUIDataTable
                  title="Lista de Usuarios Proveedor"
                  data={Object.values(this.state.users)}
                  columns={columns}
                  options={options}
                />
              </MuiThemeProvider>
            </div>
          </Col>
        </Row>
      </Container>
    );
  }
}

export default ProviderUsers;
